// /care/terms — 「덴클 케어 이용약관」 p-1.0 전문 게시 (덴클 케어 1차 W8, 2026-10-04 계획_환자앱1차_통합 · 정본 §3-1)
// 앱 동의 화면 [보기]·스토어 등록용 공개 주소. 비로그인 공개.
// 원문 = config/careLegal.js CARE_TERMS 한 곳. TODO(정본 v2 미확정)·자리표시가 남아 있거나, 웹이 계산한 해시가 textHash 와 다르면
//   원문을 보이지 않고 "준비 중"만 — 미확정 문안이 운영에 나가지 않게(빌드에 TODO 가 남아도 안전).
// 원문은 바이트 그대로 pre-wrap(해시 대상과 같은 글자).
import React, { useEffect, useState } from 'react';
import CarePageShell, { CS } from './CarePageShell';
import { CARE_TERMS, isCareTextReady, verifyCareText, normalizeLegalText } from '../../config/careLegal';

function CareTerms() {
    // 훅은 전부 최상단
    const ready = isCareTextReady(CARE_TERMS);
    const [ok, setOk] = useState(null);   // null=대조 중

    useEffect(() => {
        let alive = true;
        if (!ready) { setOk(false); return undefined; }
        verifyCareText(CARE_TERMS, CARE_TERMS.text).then(v => { if (alive) setOk(v); });
        return () => { alive = false; };
    }, [ready]);

    return (
        <CarePageShell title="덴클 케어 이용약관" meta={ok ? `판 ${CARE_TERMS.version}` : null}>
            {ok === null ? (
                <div style={CS.pending}>불러오는 중…</div>
            ) : ok ? (
                <pre style={CS.pre}>{normalizeLegalText(CARE_TERMS.text)}</pre>
            ) : (
                <div style={CS.pending}>준비 중입니다.<br />약관이 확정되면 이 주소에 게시합니다.</div>
            )}
        </CarePageShell>
    );
}

export default CareTerms;
